import { TEMPLATE_TYPE_RICH } from 'Constants/index'
import { canUseMshop, mshopBuy } from 'Helpers/mshopHelpers'
import { isOfferLight } from 'Helpers/options'
import {
  Grid,
  GRID_VARIANT_VERTICAL_BIG,
  GridCell,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  MessageBox,
  NoResults,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { fetchTemplatesCallback } from 'Pages/TemplateList/recoil/callbacks/callbacks'
import { pageState } from 'Pages/TemplateList/recoil/state/page'
import { resultsState } from 'Pages/TemplateList/recoil/state/results'
import { searchState } from 'Pages/TemplateList/recoil/state/search'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import Result from './Result'
import SkeletonResult from './SkeletonResult'

export const Results = ({ type }) => {
  const intl = useIntl()

  const { items } = useRecoilValue(resultsState)
  const { fetchingResults: loading } = useRecoilValue(pageState)
  const results = useRecoilValue(resultsState)
  const [{ searchText }] = useRecoilState(searchState)
  const hasResults = !!items.length

  const fetchTemplates = useRecoilCallback(fetchTemplatesCallback, [])

  useEffect(() => {
    fetchTemplates({ type: type, searchText: searchText })
  }, [])

  return (
    <>
      <React.Suspense fallback={null}>
        <SpacingVertical />

        {isOfferLight() && type === TEMPLATE_TYPE_RICH && (
          <>
            <MessageBox data-mu-test='templates-bee-upsell'>
              <Text htmlElement='span'>
                {intl.formatMessage({
                  id: 'Load.BaseConfigUpsell.RichTemplatesUpsell'
                })}{' '}
                {canUseMshop() ? (
                  <Link
                    variant={LINK_VARIANT_HIGHLIGHT}
                    data-mu-test='buy'
                    onClick={mshopBuy}
                  >
                    {intl.formatMessage({
                      id: 'Load.BaseConfigUpsell.RichTemplatesUpsellBuy'
                    })}
                  </Link>
                ) : (
                  <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                    {intl.formatMessage({
                      id: 'Load.BaseConfigUpsell.RichTemplatesUpsellAskBuy'
                    })}
                  </Text>
                )}
              </Text>
            </MessageBox>
            <SpacingVertical />
          </>
        )}

        <Grid cols={12} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
          <>
            {loading &&
              Array.from({ length: 12 }).map((_, index) => (
                <GridCell key={`tpl-skel-${index}`} span={3}>
                  <SkeletonResult />
                </GridCell>
              ))}
            {!loading && hasResults && (
              <>
                {results.items.map(item => (
                  <GridCell key={`tpl-${item.id}`} span={3}>
                    <Result
                      id={item.id}
                      title={item.title}
                      type={type}
                      actions={results.actions}
                    />
                  </GridCell>
                ))}
              </>
            )}
          </>
        </Grid>

        {!loading && !hasResults && (
          <NoResults
            text={intl.formatMessage({
              id: 'Load.Bee.MyTemplateNoData'
            })}
          />
        )}
      </React.Suspense>
      <SpacingVertical />
    </>
  )
}

Results.propTypes = {
  type: PropTypes.string
}
